module.exports = __webpack_public_path__ + "img/Skirt-Back-B8-Db-Fb.5a73da3b.png";